// @flow

import React, {useEffect} from 'react';

import {Headers} from './data-table-headers';
import {useHeaders} from '../hooks/use-headers';

import type {ComponentType} from 'react';
import type {HeadersProps} from './data-table-headers';


export const PinnedRowsHeader: ComponentType<HeadersProps> = (props: HeadersProps): React$Node => {
    const {
        children,
        className,
        disabledScroll,
        getHeaderTopOffset,
        stickyReferenceElement,
        stickyScroll = false,
        wrapperElement,
        ...restProps
    } = props;

    const {isSticky, headersContainer, headerRef, topPosition} = useHeaders({
        isMainHeaders: false,
        getHeaderTopOffset,
        stickyReferenceElement,
        hasPinnedRows: false,
        stickyScroll,
        wrapperElement
    });

    useEffect(() => {
        const header = headerRef.current;

        if (!header) {
            return;
        }

        if (!stickyScroll) {
            header.style.top = `${topPosition}px`;
            return;
        }

        header.style.position = 'relative';
        header.style.willChange = 'transform';

        const onScroll = () => {
            if (!headersContainer.current) {
                return;
            }

            const top = headersContainer.current.getBoundingClientRect().top;

            if (top < topPosition) {
                header.style.transform = `translate3d(0, ${topPosition - top}px, 0)`;
            } else {
                header.style.transform = 'translate3d(0, 0, 0)';
            }
        };

        onScroll();
        (wrapperElement ?? window).addEventListener('scroll', onScroll);

        return () => (wrapperElement ?? window).removeEventListener('scroll', onScroll);
    }, [topPosition, stickyScroll, wrapperElement]);

    return (
        <Headers
            {...restProps}
            className={className}
            disabledScroll={disabledScroll}
            isSticky={isSticky}
            headersContainer={headersContainer}
            headerRef={headerRef}>
            {children}
        </Headers>
    );
};

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./data-table-headers");
